import React, { useCallback, useState, useMemo } from 'react';
import { InputProps } from './types/Input.types';
import clsx from 'clsx';

const RadioButton: React.FC<
  InputProps & React.InputHTMLAttributes<HTMLInputElement>
> = ({
  inputSize = 'medium',
  inputState = 'default',
  wrapperClassName,
  label,
  ...props
}) => {
  const sizeClass = useMemo(() => {
    switch (inputSize) {
      case 'small':
      case 'xsmall':
        return 'checkbox-wrapper--sm';
      case 'large':
        return 'checkbox-wrapper--lg';
      case 'xlarge':
        return 'checkbox-wrapper--xl';
      case 'medium':
      default:
        return 'checkbox-wrapper--md';
    }
  }, [inputSize]);

  return (
    <div className={clsx(wrapperClassName, 'checkbox-wrapper', sizeClass)}>
      <label htmlFor={props.id}>
        <input type="radio" className="radio" {...props} />
        {label && <span className="w-full">{label}</span>}
      </label>
    </div>
  );
};

export default RadioButton;
